import { ResponseGetPogAnalysis_OutputStorePogId_ } from "@CommonApi/pog-analysis/_outputStorePogId_";
import { omniAtom } from "src/utils/atoms";

const prefix = "modals/PogSummaryModal";

export const pogSummaryModalDataAtom = omniAtom({
  prefix,
  key: "data",
  value: null as ResponseGetPogAnalysis_OutputStorePogId_ | null,
});
